import {Provider} from '@angular/core';

import {FacebookConfig} from '../config/facebook.config';

export const FACEBOOK_PROVIDERS: Provider[] = [
    {
        provide: FacebookConfig,
        useClass: FacebookConfig
    }
];
